import {StyleSheet} from 'react-native';

const style = StyleSheet.create({
  contentContainerStyle: {
    flexGrow: 1,
  },
});

export {style};
